import { DeleteAccountMessages, TranslationDeleteAccountMessages } from "@languages/interfaces";

export const messages: TranslationDeleteAccountMessages = {
  [DeleteAccountMessages.stepOne]: "Excluir minha conta Topcon Customer",
  [DeleteAccountMessages.description]: `A exclusão da sua conta fará com que você
    perca totalmente o acesso ao Topcon Customer, e essa ação não pode ser revertida, e para um novo
    acesso será necessário criar um novo usuário. Para continuar a exclusão, siga os passos a seguir:`,
  [DeleteAccountMessages.stepTwo]: "Confirme a exclusão da conta",
  [DeleteAccountMessages.stepThree]: "Insira sua senha Topcon Customer",
  [DeleteAccountMessages.deleteButton]: "Excluir minha conta",
  [DeleteAccountMessages.checkConfirmDeletion]: `Desejo excluir todos os meus dados
    da conta, incluindo, meu usuário, programações, contratos, faturas, aprovações, laudos e permissões
    e outros.`,
  [DeleteAccountMessages.deleteAccountFailed]: "Falha ao excluir conta"
};
